import { render, staticRenderFns } from "./DetalhesdaAposta.vue?vue&type=template&id=a6d65fb0&scoped=true"
import script from "./DetalhesdaAposta.vue?vue&type=script&lang=js"
export * from "./DetalhesdaAposta.vue?vue&type=script&lang=js"
import style0 from "./DetalhesdaAposta.vue?vue&type=style&index=0&id=a6d65fb0&prod&lang=css"
import style1 from "./DetalhesdaAposta.vue?vue&type=style&index=1&id=a6d65fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d65fb0",
  null
  
)

export default component.exports